import { render, staticRenderFns } from "./Alunno.vue?vue&type=template&id=42d11815&scoped=true&"
import script from "./Alunno.vue?vue&type=script&lang=ts&"
export * from "./Alunno.vue?vue&type=script&lang=ts&"
import style0 from "./Alunno.vue?vue&type=style&index=0&id=42d11815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d11815",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VProgressCircular,VRow,VTab,VTabItem,VTabs,VTabsItems})
